import * as Yup from 'yup';

export default (yup: typeof Yup) => ({
  name: yup.string()
    .max(191)
    .required(),
  apps: yup.array().required(),
});
